<template>
	<div id="Main">
		<div v-if="details==''">数据加载中...</div>
		<div class="box" v-if="details!=''">
			<p class="name">{{details.bussinessTypeName}}</p>
			<div class="content">
				<div class="item">
					<p class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/name.png')" />股东姓名</p>
					<p class="data">{{details.shareholdeName}}</p>
				</div>
				<div class="item">
					<p class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/mycode.png')" />股东代码</p>
					<p class="data">{{details.shareholdeCode}}</p>
				</div>
			</div>
			<van-row type="flex" justify="space-between" class="time">
				<van-col class="screen">申请时间：{{details.applyDate}}</van-col>
				<van-col class="">
					<van-icon class="icon" :name="require('../../assets/images/service/move.png')" />
				</van-col>
			</van-row>
		</div>
		<div class="box1" v-if="type == 1">
			<div class="htitle">
				<p class="p1">申请信息明细</p>
			</div>
			
			<div v-for="(item,index) in bonus" :key="index">
				<p class="name">{{item.stockJiancheng!='0.00'?item.stockJiancheng:'其他'}}</p>
				<div class="content">
					<div class="item">
						<p class="title"><van-icon class="icon" :name="require('../../assets/images/service/details1.png')" />股权代码</p>
						<p class="data">{{item.stockCode}}</p>
					</div>
					<div class="item">
						<p class="title"><van-icon class="icon" :name="require('../../assets/images/service/details5.png')" />红利金额</p>
						<p class="data">{{item.bonus}}</p>
					</div>
					<div class="item">
						<p class="title"><van-icon class="icon" :name="require('../../assets/images/service/details6.png')" />红利名称</p>
						<p class="data">{{item.bonusName}}</p>
					</div>
					<div class="item">
						<p class="title"><van-icon class="icon" :name="require('../../assets/images/service/details4.png')" />冻结标志</p>
						<p class="data">{{item.frozenSign!='0.00'?item.frozenSign:'其他'}}</p>
					</div>
				</div>
			</div>
		</div>
		<div class="box1">
			<div class="htitle" >
				<p class="p1">红利总金额:{{totalmoney.toFixed(2)}}元</p>
			</div>
			
		</div>
		
		<div class="box1" v-if="type == 1">
			<div class="htitle">
				<p class="p1">银行卡信息</p>
			</div>
			<div class="card">
				<div class="inputbox">
					<span class="label">
						<van-icon class="icon" :name="require('../../assets/images/service/user.png')" />持卡人姓名</span>
					<van-field class="input" :value="details.shareholdeName" readonly />
				</div>
				<div class="inputbox">
					<span class="label">
						<van-icon class="icon" :name="require('../../assets/images/service/card.png')" />开户行</span>
					<van-field class="input" :value="details.bank" readonly />
				</div>
				<div class="inputbox">
					<span class="label">
						<van-icon class="icon" :name="require('../../assets/images/service/card.png')" />银行卡号</span>
					<van-field class="input" :value="details.card" readonly />
				</div>
			</div>
		</div>
		<div class="box" v-if="type != 1">
			<p class="name">申请信息明细</p>
			<div class="form">
				<div class="inputbox">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/account_1.png')" />
						<span>企业代码</span><span v-if="details.bussinessType==3" class="ico">*</span>
					</div>
					<van-field class="input" :value="details.companyCode" readonly type="text"/>
				</div>
				<div class="inputbox">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/codeicon_1.png')" />
						<span>企业简称</span><span v-if="details.bussinessType==3" class="ico">*</span>
					</div>
					<van-field class="input" readonly :value="details.companyShortName" type="text"/>
				</div>
				<div class="inputbox" v-if="details.bussinessType==2 || details.bussinessType==3">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/codeicon_1.png')" />
						<span>过户数量</span><span class="ico">*</span>
					</div>
					<van-field class="input" readonly :value="details.transferNum" type="text"/>
				</div>
				<div class="inputbox" v-if="details.bussinessType==2 || details.bussinessType==3">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/codeicon_1.png')" />
						<span>过户原因</span>
					</div>
					<van-field class="input" readonly :value="details.transferReason" type="text"/>
				</div>
				<div class="inputbox" v-if="details.bussinessType==3">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/codeicon_1.png')" />
						<span>过出方姓名</span><span class="ico">*</span>
					</div>
					<van-field class="input" readonly :value="details.comeName" type="text"/>
				</div>
				<div class="inputbox" v-if="details.bussinessType==3">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/codeicon_1.png')" />
						<span>过出方证件类型</span>
					</div>
					<van-field class="input" readonly :value="details.comeIdcardType" type="text"/>
				</div>
				<div class="inputbox" v-if="details.bussinessType==3">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/codeicon_1.png')" />
						<span>过出方证件号码</span><span class="ico">*</span>
					</div>
					<van-field class="input" readonly :value="details.comeIdcard" type="text"/>
				</div>
				<div class="inputbox" v-if="details.bussinessType==3">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/codeicon_1.png')" />
						<span>过出方账户号</span>
					</div>
					<van-field class="input" readonly :value="details.comeUsername" type="text"/>
				</div>
			
				<div class="inputbox" v-if="details.bussinessType==2">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/codeicon_1.png')" />
						<span>过入方姓名</span><span class="ico">*</span>
					</div>
					<van-field class="input" readonly :value="details.toName" type="text"/>
				</div>
				<div class="inputbox" v-if="details.bussinessType==2">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/codeicon_1.png')" />
						<span>过入方证件类型</span>
					</div>
					<van-field class="input" readonly :value="details.toIdcardType" type="text"/>
				</div>
				<div class="inputbox" v-if="details.bussinessType==2">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/codeicon_1.png')" />
						<span>过入方证件号码</span><span class="ico">*</span>
					</div>
					<van-field class="input" readonly :value="details.toIdcard" type="text"/>
				</div>
				<div class="inputbox" v-if="details.bussinessType==2">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/codeicon_1.png')" />
						<span>过入方账户号</span>
					</div>
					<van-field class="input" readonly :value="details.toUsername" type="text"/>
				</div>
<!-- 				<div class="inputbox" v-if="details.bussinessType==4">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/codeicon_1.png')" />
						<span>质押数量</span>
					</div>
					<van-field class="input" readonly :value="details.pledgeNum" type="text"/>
				</div>
				<div class="inputbox" v-if="details.bussinessType==5">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/codeicon_1.png')" />
						<span>解除质押数量</span>
					</div>
					<van-field class="input" readonly :value="details.relievePledgeNum" type="text"/>
				</div> -->
			</div>
		</div>
		<div class="box" v-if="type != 1">
			<div class="htitle">
				<p class="p1">上传的资料</p>
			</div>
			<van-row type="flex" class="loaderbox">
				<van-col class="loaderimg" v-for="(item,index) in img" :key="index">
					<div class="pos">
						<van-image @click="previewImg(index)" width="100%" height="100%" fit="contain" :src="item" />
					</div>
				</van-col>
			</van-row>
		</div>
		<div class="step" :class="{'last-step': index === details.records.length - 1}" v-for="(item,index) in details.records" :key="index">
			<div class="list on">
				<!-- 只展示处理了的 -->
				<van-image class="icon" v-if="true" width="2rem" fit="contain" :src="require('../../assets/images/service/stepicon.png')" />
				<van-image class="icon" v-if="false" width="2rem" fit="contain" :src="require('../../assets/images/service/stepic.png')" />
				<p class="title">{{item.dealTypeName}}</p>
				<p class="text">{{item.instructions}}</p>
				<p class="time">{{item.updateDate}}</p>
			</div>
		</div>
		<van-image-preview v-model="show" :images="img" :start-position="previewIndex">
		</van-image-preview>
	</div>
</template>
<script>
	import axiosPost from '../../libs/moudle/index.js';
	export default {
		components: {},
		data() {
			return {
				id: '',
				details: '',
				img: [],
				imgUrl: '',
				show: false,
				previewIndex: 0,
				type: '',
				totalmoney:0,//红利总数
				bonus:[],//红利明细
			}
		},
		methods: {
			getdata() { /* 获取申请详情 */
				axiosPost.listdetails({
					id: this.id
				}).then((res) => {
					window.console.log(res.data.data)
					let data = res.data.data
					
					if (data.bussinessType == 1) {
						this.details = data;
						this.type = 1;
						let bonus=JSON.parse(data.bonus);
						this.bonus=bonus;
						if(bonus){
							for(let v of bonus){
								window.console.log('v.bonus-----',v.bonus);
								let money=v.bonus.split('元')[0];
								window.console.log('money---',money);
								this.totalmoney=Number(this.totalmoney)+Number(money);
							}
						}
						window.console.log('this.bonus',bonus);
						return
					}
					
					if (res.data.code == 200) {
						this.details = res.data.data;
						this.img = res.data.data.img.split(',').map(i => (this.imgUrl + i))
					} else {
						this.$toast({duration:4000,message:res.data.msg});
					}
					
				}).catch((res) => {
					window.console.log(res)
				})
			},
			previewImg(index) {
				this.show = true
				this.previewIndex = index
			}
		},
		mounted() {
			this.imgUrl = axiosPost.imgUrl
			this.id = this.$route.query.id
			this.getdata();
		},
	}
</script>

<style lang="scss" scoped>
	#Main {
		padding: 1.3rem;
		min-height: 100vh;
		background-color: #f2f9ff;
		
		.step:nth-child(2) {
			padding-top: 3rem;
		}
		
		.step {
			position: relative;
			padding-bottom: 3rem;
			
			&:after {
				width: 1px;
				height: 100%;
				background-color: #666666;
				position: absolute;
				top: 0;
				left: 2rem;
				content: '';
				display: block;
			}

			.list {
				text-align: left;
				color: #999999;
				// padding: 2rem 0;
				margin-left: 5rem;
				position: relative;

				.icon {
					position: absolute;
					top: 0;
					left: -4rem;
					background-color: #f2f9ff;
					z-index: 2;
				}

				.title {
					font-size: 1.8rem;
					line-height: 2rem;
				}

				.text {
					font-size: 1.5rem;
					line-height: 1.6rem;
					margin: 0.5rem 0;
				}

				.time {
					font-size: 1rem;
					line-height: 1rem;
					color: #999999;
				}
			}

			.list.on {
				color: #333333;

				.time {
					color: #999999;
				}
			}
		}
		.last-step:after {
			width: 0;
		}
		
		.box:nth-child(n + 2) {
			margin-top: 2rem;
		}

		.box {
			background-color: #fff;
			border-radius: 8px;
			padding: 0 1rem;
			box-shadow: 0 2px 5px 1px #e4ebfa;

			.time {
				font-size: 1.4rem;
				color: #999999;
				line-height: 3.5rem;

				.icon {
					font-size: 2rem;
					line-height: 3.5rem;
				}
			}

			.name {
				text-align: left;
				font-size: 1.8rem;
				color: #333;
				line-height: 3.5rem;
				padding-top: 0.6rem;
				font-weight: bold;
			}

			.content {
				display: flex;
				flex-wrap: wrap;

				.item {
					width: 50%;
					padding: 1rem 0;
					border-top: 1px solid #e0dfdf;
					border-bottom: 1px solid #e0dfdf;
					font-size: 0;
					line-height: 2rem;

					&:nth-child(2n) {
						border-left: 1px solid #e0dfdf;
					}

					.title {
						font-size: 1.5rem;
						color: #8c8b8b;

						.icon {
							margin-right: 0.5rem;
							vertical-align: middle;
						}
					}

					.data {
						color: #333333;
						font-size: 1.6rem;
					}
				}
			}
			
			.form {
				padding-bottom: 3rem;
			
				.inputbox {
					padding: 1rem 0;
					padding-left: 3rem;
			
					.input {
						flex: 1;
						padding: 0;
						height: 4rem;
						line-height: 4rem;
						border-bottom: 1px solid #e0dfdf;
			
						&:not(:last-child):after {
							display: none;
						}
					}
			
					.select {
						color: #a0a0a0;
					}
				}
			
				.title {
					text-align: left;
					line-height: 2.5rem;
					margin-left: -2.3rem;
			
					span {
						font-weight: bold;
						font-size: 1.6rem;
						color: #333;
					}
			
					.ico {
						color: #fa6b6b;
						display: inline-block;
						margin-left: 5px;
					}
			
					.icon {
						vertical-align: -0.25rem;
						margin-right: 0.8rem;
					}
				}
			}
			.htitle {
				margin-bottom: 1rem;
				padding-top: 1rem;
				text-align: left;
			
				.p1 {
					font-weight: bold;
					color: #161616;
					font-size: 1.8rem;
					line-height: 2.5rem;
				}
			
				.p2 {
					color: #999999;
					font-size: 1.4rem;
					line-height: 2rem;
				}
			}
		}
		
		.loaderbox {
			width: 100%;
			flex-wrap: wrap;
			margin: 1.5rem 0;
			.loaderimg {
				width: 30%;
				padding: 15% 0;
				margin-right: 5%;
				position: relative;
				margin-bottom: 1.5rem;
				.pos {
					position: absolute;
					top: 0;
					left: 0;
					bottom: 0;
					right: 0;
				}
		
				&:nth-child(3n) {
					margin-right: 0;
				}
			}
		}
	}
	.box1 {
		background-color: #fff;
		border-radius: 8px;
		padding:0 1rem;
		margin: 2rem 0;

		.name{
			text-align: left;
			font-size: 1.8rem;
			color: #333;
			line-height: 3.5rem;
			padding-top: 0.6rem;
			font-weight: bold;
		}
		.content{
			display: flex;
			flex-wrap: wrap;
			.item{
				width: 50%;
				padding: 1rem 0;
				border-top:  1px solid #e0dfdf;
				font-size: 0;
				line-height: 2rem;
				&:nth-child(2n){
					border-left: 1px solid #e0dfdf;
				}
				.title{
					font-size: 1.5rem;
					color: #8c8b8b;
					.icon{
						margin-right: 0.5rem;
						vertical-align: middle;
					}
				}
				.data{
					color: #333333;
					font-size: 1.6rem;
				}
			}
		}
		.htitle {
			padding: 1rem 0;
			text-align: left;
			border-bottom: 1px solid #e0dfdf;
			font-weight: 700;
		}
		.inputbox {
			display: flex;
			margin-bottom: 0.8rem;
			margin-left: auto;
			margin-right: auto;
			border-bottom: 1px solid #ebebeb;
			padding: 1rem 0;
			line-height: 2.4rem;
			&:last-child{
				margin-bottom: 0;
				border-bottom: 0;
			}
			.input {
				padding: 0 1rem 0 0;
				flex: 1;
				line-height: 2.4rem;
				font-size: 1.6rem;
		
				input {
					color: #333333;
				}
			}
		
			.label {
				color: #fa6b6b;
				font-size: 1.6rem;
				margin-right: 0.6rem;
			}
		
			.icon {
				vertical-align: -0.2rem;
				margin-right: 0.6rem;
			}
		
		}
	}
	.card{
		.label{
			width: 11rem;
			text-align-last:justify;
			text-align:justify;
			text-justify:distribute-all-lines;
			position: relative;
			padding-left: 1.7rem;
			padding-right: 1.2rem;
			margin-right: 0rem;
			.icon{
				position: absolute;
				left:0;
				top:50%;
				transform: translateY(-50%);
			}
			&:before{
				content: "：";
				position: absolute;
				right:0;
				top:50%;
				transform: translateY(-50%);
				display: block;
			}
		}
	}
</style>
